"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4518],{

/***/ 74518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Form_ModernForm1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/redux/actions/widgets.js
var widgets = __webpack_require__(95455);
// EXTERNAL MODULE: ./src/utils/isValidEmail.js
var isValidEmail = __webpack_require__(26188);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(61903);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 8 modules
var utils_common = __webpack_require__(77297);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/constants/common.ts
var constants_common = __webpack_require__(17584);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/common/FormCFEComponent.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2.5rem;\n  width: 100%;\n  border: 0.4px solid #fff;\n  background: ",
        ";\n  border: none;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 25px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  word-wrap: break-word;\n  font-weight: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n  overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  color: #fff;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: ",
        ";\n  line-height: normal;\n  letter-spacing: -0.503px;\n  opacity: 0.6;\n  word-wrap: break-word;\n  color: ",
        ";\n  font-family: ",
        ";\n  overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n  overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 1rem 0.75rem;\n  border: 1px solid black;\n  text-align: center;\n  cursor: pointer;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: -0.503px;\n  background: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  :hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 6px 16px;\n  background: #ff3838;\n  width: 100%;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: -0.503px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormContainer",
    componentId: "sc-1bcaf941-0"
})(_templateObject(), function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : ref.backgroundColor;
});
var FormContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormContent",
    componentId: "sc-1bcaf941-1"
})(_templateObject1());
var FormHeadingContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FormHeadingContainer",
    componentId: "sc-1bcaf941-2"
})(_templateObject2());
var FormHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormHeading",
    componentId: "sc-1bcaf941-3"
})(_templateObject3(), function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color) || "#FFFF00";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
});
var FormDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormDescription",
    componentId: "sc-1bcaf941-4"
})(_templateObject4(), function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color) || "#FFFF00";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
});
var FormCTAButtons = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FormCTAButtons",
    componentId: "sc-1bcaf941-5"
})(_templateObject5());
var CTAButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "CTAButton",
    componentId: "sc-1bcaf941-6"
})(_templateObject6(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.backgroundHoverColor;
});
var FormInputContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FormInputContainer",
    componentId: "sc-1bcaf941-7"
})(_templateObject7());
var InputTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputTextContainer",
    componentId: "sc-1bcaf941-8"
})(_templateObject8());
var TextFieldContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TextFieldContainer",
    componentId: "sc-1bcaf941-9"
})(_templateObject9());
var ErrorField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorField",
    componentId: "sc-1bcaf941-10"
})(_templateObject10());
var FormCloseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormCloseIcon",
    componentId: "sc-1bcaf941-11"
})(_templateObject11());

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/common/FormCFEComponent.js


















function CrossIcon(props) {
    var fillColor = props.fillColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_3356_639)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
                    fill: fillColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3356_639",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
var CssTextField = (0,styled/* default */.ZP)(TextField/* default */.Z)(function(props) {
    return {
        // label when focussed
        "& label.Mui-focused": {
            color: props.labelFocusedColor,
            opacity: 0.8
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#B2BAC2"
        },
        "& .MuiFormControl-root": {
            width: "100%"
        },
        "& .MuiOutlinedInput-root": {
            padding: "10px",
            width: "100%",
            "& fieldset": {
                borderColor: "#E0E3E7"
            },
            "&:hover fieldset": {
                borderColor: "#B2BAC2"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#6F7E8C"
            }
        },
        "& input::placeholder": {
            color: "blue"
        }
    };
});
var FormCFEComponent = function(props) {
    var ref, ref1, ref2;
    var heading = props.heading, description = props.description, buttonText = props.buttonText, buttonConfig = props.buttonConfig, toggleFormCompletion = props.toggleFormCompletion;
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer,
            storeData: state.storeReducer.store
        };
    }), widgetData = ref3.widgetData, storeData = ref3.storeData;
    var ref4 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template), propStyle = ref4[0], setPropStyle = ref4[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref5 = (0,react.useState)({
        name: "",
        phone: "",
        email: "",
        description: ""
    }), formInput = ref5[0], setFormInput = ref5[1];
    (0,react.useEffect)(function() {
        setFormInput({
            name: "",
            phone: "",
            email: "",
            description: ""
        });
    }, [
        props === null || props === void 0 ? void 0 : props.open
    ]);
    var ref6 = (0,react.useState)({
        name: true,
        phone: true,
        email: true,
        description: true
    }), fieldValidity = ref6[0], setFieldValidity = ref6[1];
    var validateFields = function() {
        var isValidName = formInput.name.length >= 3;
        var isValidPhone = formInput.phone.length === 10;
        var isEmailValid = formInput.email.length === 0 || (0,isValidEmail/* isValidEmail */.v)(formInput.email);
        setFieldValidity({
            name: isValidName,
            phone: isValidPhone,
            email: isEmailValid,
            description: true
        });
        return isValidName && isValidPhone && isEmailValid;
    };
    var getColorsForFormInput = function(type) {
        switch(type){
            case "input":
                return (0,utils_common/* hexToRgba */.a7)(propStyle === null || propStyle === void 0 ? void 0 : propStyle.borderColor, 0.4);
            case "label":
                return (0,utils_common/* hexToRgba */.a7)(propStyle === null || propStyle === void 0 ? void 0 : propStyle.borderColor, 0.8);
        }
    };
    var handleFormInputChange = function(type, value) {
        if (type === "phone") {
            value = value.replace(/\D/g, ""); // Remove non-numeric characters
        }
        setFormInput(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, type, value));
        });
    };
    var inputStyleConfig = {
        input: {
            color: getColorsForFormInput("input"),
            "&::placeholder": {
                // <----- Add this.
                opacity: 1
            }
        },
        label: {
            color: getColorsForFormInput("label"),
            opacity: "0.6",
            fontSize: "14px",
            fontWeight: "400"
        }
    };
    var inputStyleLastConfig = {
        input: {
            color: getColorsForFormInput("input"),
            height: "80px",
            "&::placeholder": {
                // <----- Add this.
                opacity: 1
            }
        },
        label: {
            color: getColorsForFormInput("label"),
            opacity: "0.6",
            fontSize: "14px",
            fontWeight: "400"
        }
    };
    var handleDownload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, pdfUrlPath, ref3, response, blob, url, link, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!buttonConfig || !(buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref = buttonConfig.config) === null || ref === void 0 ? void 0 : ref.downloadContent)) return [
                            2
                        ];
                        pdfUrlPath = (ref1 = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.content[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.actions) === null || ref2 === void 0 ? void 0 : ref2.handler;
                        if (pdfUrlPath === "") return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch(pdfUrlPath)
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.blob()
                        ];
                    case 3:
                        blob = _state.sent();
                        url = window.URL.createObjectURL(blob);
                        link = document.createElement("a");
                        link.href = url;
                        // Set the download attribute with the desired file name
                        link.download = (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref3 = buttonConfig.config) === null || ref3 === void 0 ? void 0 : ref3.fileName) || "Download";
                        // Append the link to the document
                        document.body.appendChild(link);
                        // Trigger a click on the link
                        link.click();
                        // Remove the link from the document
                        document.body.removeChild(link);
                        // Release the object URL
                        window.URL.revokeObjectURL(url);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Error downloading file:", error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    /** This function returns final payload where name and phone is must have and other keys are only sent if the value is not empty */ var getFormData = function() {
        var finalResponse = {
            name: formInput.name,
            phone: formInput.phone
        };
        if (formInput.email.length > 0) {
            finalResponse["email"] = formInput.email;
        }
        if (formInput.description.length > 0) {
            finalResponse["description"] = formInput.description;
        }
        return finalResponse;
    };
    var router = (0,next_router.useRouter)();
    var isBrandWebsiteDemo = router.pathname.includes("/brand-website-theme-demo");
    var submitForm = function() {
        var ref, ref1, ref2;
        if (!validateFields()) {
            return;
        }
        var payload = {
            store_id: props === null || props === void 0 ? void 0 : (ref = props.storeData) === null || ref === void 0 ? void 0 : ref.store_id,
            store_theme_id: props === null || props === void 0 ? void 0 : (ref1 = props.storeData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.theme) === null || ref2 === void 0 ? void 0 : ref2.store_theme_id,
            widget_id: props.widgetId,
            theme_category: constants_common/* FORM_TYPE.BRAND_THEME */.PE.BRAND_THEME,
            content: getFormData()
        };
        !isBrandWebsiteDemo ? dispatch((0,widgets/* submitFormData */.EQ)(payload, function(status) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            if (status) {
                handleDownload();
                toggleFormCompletion(true);
            } else {
                (0,Toast/* toastNotifyError */.Lu)(message || "Error submitting form!!");
                props.onClose();
            }
        })) : toggleFormCompletion(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
        themeStyle: propStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCloseIcon, {
                    onClick: props.onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon, {
                        fillColor: propStyle === null || propStyle === void 0 ? void 0 : (ref2 = propStyle.heading) === null || ref2 === void 0 ? void 0 : ref2.color
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormHeadingContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHeading, {
                            textStyles: propStyle,
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDescription, {
                            textStyles: propStyle,
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextFieldContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssTextField, {
                                    id: "outlined-basic",
                                    variant: "outlined",
                                    label: "Name",
                                    value: formInput === null || formInput === void 0 ? void 0 : formInput.name,
                                    sx: inputStyleConfig,
                                    onChange: function(e) {
                                        return handleFormInputChange("name", e.target.value);
                                    },
                                    labelFocusedColor: getColorsForFormInput("label")
                                }),
                                !fieldValidity.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorField, {
                                    children: "Please enter a valid name"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextFieldContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssTextField, {
                                    id: "outlined-basic",
                                    variant: "outlined",
                                    label: "Phone Number",
                                    sx: inputStyleConfig,
                                    value: formInput === null || formInput === void 0 ? void 0 : formInput.phone,
                                    inputProps: {
                                        maxLength: 10
                                    },
                                    onChange: function(e) {
                                        return handleFormInputChange("phone", e.target.value);
                                    },
                                    labelFocusedColor: getColorsForFormInput("label")
                                }),
                                !fieldValidity.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorField, {
                                    children: "Please enter a valid phone number"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextFieldContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssTextField, {
                                    id: "outlined-basic",
                                    variant: "outlined",
                                    label: "Email(optional)",
                                    sx: inputStyleConfig,
                                    value: formInput === null || formInput === void 0 ? void 0 : formInput.email,
                                    onChange: function(e) {
                                        return handleFormInputChange("email", e.target.value);
                                    },
                                    labelFocusedColor: getColorsForFormInput("label")
                                }),
                                !fieldValidity.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorField, {
                                    children: "Please enter a valid email"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextFieldContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssTextField, {
                                    id: "outlined-basic",
                                    variant: "outlined",
                                    label: "Write your message(optional)",
                                    sx: inputStyleLastConfig,
                                    value: formInput === null || formInput === void 0 ? void 0 : formInput.description,
                                    onChange: function(e) {
                                        return handleFormInputChange("description", e.target.value);
                                    },
                                    labelFocusedColor: getColorsForFormInput("label")
                                }),
                                !fieldValidity.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorField, {
                                    children: "Please enter a valid description"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCTAButtons, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                        themeStyles: propStyle,
                        onClick: submitForm,
                        children: buttonText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var common_FormCFEComponent = (FormCFEComponent);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/common/FormCompletion.styled.js

function FormCompletion_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2.5rem;\n  width: 100%;\n  border: 0.4px solid ",
        ";\n  background: ",
        ";\n  border: none;\n  height: 100%;\n"
    ]);
    FormCompletion_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n"
    ]);
    FormCompletion_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  height: 350px;\n"
    ]);
    FormCompletion_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n"
    ]);
    FormCompletion_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  text-align: center;\n  font-size: 40px;\n  font-style: normal;\n  line-height: normal;\n  font-weight: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n  overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n"
    ]);
    FormCompletion_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: -0.503px;\n  opacity: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n  overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n"
    ]);
    FormCompletion_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormCompletion_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 1rem 0.75rem;\n  text-align: center;\n  cursor: pointer;\n  //   font-family: DM Sans;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: -0.503px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  font-size: ",
        "rem;\n  font-family: ",
        ";\n  &:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n"
    ]);
    FormCompletion_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n"
    ]);
    FormCompletion_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function FormCompletion_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    FormCompletion_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var FormCompletion_styled_FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormContainer",
    componentId: "sc-e99f20d2-0"
})(FormCompletion_styled_templateObject(), function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyle) === null || ref === void 0 ? void 0 : ref.backgroundColor;
});
var FormCompletion_styled_FormContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormContent",
    componentId: "sc-e99f20d2-1"
})(FormCompletion_styled_templateObject1());
var FormCompletion_styled_FormHeadingContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FormHeadingContainer",
    componentId: "sc-e99f20d2-2"
})(FormCompletion_styled_templateObject2());
var CompletionImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompletionImage",
    componentId: "sc-e99f20d2-3"
})(FormCompletion_styled_templateObject3());
var FormCompletion_styled_FormHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormHeading",
    componentId: "sc-e99f20d2-4"
})(FormCompletion_styled_templateObject4(), function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "700";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color) || "#FFFF00";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
});
var FormCompletion_styled_FormDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormDescription",
    componentId: "sc-e99f20d2-5"
})(FormCompletion_styled_templateObject5(), utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color) || "#FFFF00";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
});
var FormCompletion_styled_FormCTAButtons = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FormCTAButtons",
    componentId: "sc-e99f20d2-6"
})(FormCompletion_styled_templateObject6());
var FormCompletion_styled_CTAButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "CTAButton",
    componentId: "sc-e99f20d2-7"
})(FormCompletion_styled_templateObject7(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.textFontSize) || 1;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var FormCompletion_styled_FormInputContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FormInputContainer",
    componentId: "sc-e99f20d2-8"
})(FormCompletion_styled_templateObject8());
var FormCompletion_styled_InputTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputTextContainer",
    componentId: "sc-e99f20d2-9"
})(FormCompletion_styled_templateObject9());

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/common/FormCompletion.js





function TickMark(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "65",
        viewBox: "0 0 65 65",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "32.5",
                cy: "32.5",
                r: "32.5",
                fill: props.bgColor || "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1162 33.4849L25.2778 44.6465L37.7526 32.1718L50.2273 19.697",
                stroke: props.color || "#333",
                "stroke-width": "5.90909",
                "stroke-linecap": "round"
            })
        ]
    });
}
var FormCompletion = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer,
            storeData: state.storeReducer.store
        };
    }), widgetData = ref4.widgetData, storeData = ref4.storeData;
    var ref5 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template), propStyle = ref5[0], setPropStyle = ref5[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCompletion_styled_FormContainer, {
        themeStyle: propStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormCompletion_styled_FormContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormCompletion_styled_FormHeadingContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompletionImage, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TickMark, {
                                bgColor: propStyle === null || propStyle === void 0 ? void 0 : (ref2 = propStyle.buttonPrimary) === null || ref2 === void 0 ? void 0 : ref2.backgroundColor,
                                color: propStyle === null || propStyle === void 0 ? void 0 : (ref3 = propStyle.buttonPrimary) === null || ref3 === void 0 ? void 0 : ref3.color
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCompletion_styled_FormHeading, {
                            textStyles: propStyle,
                            children: "Completed Successfully"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCompletion_styled_FormCTAButtons, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCompletion_styled_CTAButton, {
                        themeStyles: propStyle,
                        onClick: props.onClose,
                        children: "Close"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var common_FormCompletion = (FormCompletion);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/Desktop/index.js







var ModernFormDesktop = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var open = props.open, handleClose = props.handleClose;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var themeFormConfig = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Body) === null || ref2 === void 0 ? void 0 : ref2.filter(function(comp) {
        return comp.sub_type === "Form";
    });
    var ref5 = (0,react.useState)(false), isFormSubmit = ref5[0], setIsFormSubmit = ref5[1];
    var ref6 = (0,react.useState)(null), formConfig = ref6[0], setFormConfig = ref6[1];
    var ref7 = (0,react.useState)({}), transformedState = ref7[0], setTransfomedState = ref7[1];
    (0,react.useEffect)(function() {
        if (themeFormConfig && (themeFormConfig === null || themeFormConfig === void 0 ? void 0 : themeFormConfig.length) > 0) {
            setFormConfig(themeFormConfig[0]);
        }
    }, [
        themeFormConfig
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setTransfomedState((0,common/* transformWidgetProps */.Ak)(formConfig === null || formConfig === void 0 ? void 0 : (ref = formConfig.config) === null || ref === void 0 ? void 0 : ref.children));
    }, [
        formConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        onClose: handleClose,
        PaperProps: {
            style: {
                width: 400
            }
        },
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: isFormSubmit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FormCompletion, {
            onClose: handleClose
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FormCFEComponent, {
            heading: (transformedState === null || transformedState === void 0 ? void 0 : (ref3 = transformedState.heading) === null || ref3 === void 0 ? void 0 : ref3.text) || "",
            description: (transformedState === null || transformedState === void 0 ? void 0 : (ref4 = transformedState.description) === null || ref4 === void 0 ? void 0 : ref4.text) || "",
            buttonText: transformedState.button ? transformedState.button.content[0].btnText : "",
            buttonConfig: transformedState.button ? transformedState.button : null,
            storeData: storeData,
            widgetId: formConfig === null || formConfig === void 0 ? void 0 : formConfig.widget_id,
            toggleFormCompletion: setIsFormSubmit,
            onClose: handleClose,
            open: open
        })
    });
};
/* harmony default export */ var Desktop = (ModernFormDesktop);

// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx + 1 modules
var Modal = __webpack_require__(90429);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/Mobile/index.js







var ModernFormMobile = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var open = props.open, handleClose = props.handleClose;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var themeFormConfig = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Body) === null || ref2 === void 0 ? void 0 : ref2.filter(function(comp) {
        return comp.sub_type === "Form";
    });
    var ref5 = (0,react.useState)(false), isFormSubmit = ref5[0], setIsFormSubmit = ref5[1];
    var ref6 = (0,react.useState)(null), formConfig = ref6[0], setFormConfig = ref6[1];
    var ref7 = (0,react.useState)({}), transformedState = ref7[0], setTransfomedState = ref7[1];
    (0,react.useEffect)(function() {
        if (themeFormConfig && (themeFormConfig === null || themeFormConfig === void 0 ? void 0 : themeFormConfig.length) > 0) {
            setFormConfig(themeFormConfig[0]);
        }
    }, [
        themeFormConfig
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setTransfomedState((0,common/* transformWidgetProps */.Ak)(formConfig === null || formConfig === void 0 ? void 0 : (ref = formConfig.config) === null || ref === void 0 ? void 0 : ref.children));
    }, [
        formConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            visible: open,
            className: "bottom-modal",
            animation: "slideUp",
            onClose: handleClose,
            // style={{ padding: 0 }}
            customStyles: {
                padding: "0px",
                maxHeight: "100%"
            },
            children: isFormSubmit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FormCompletion, {
                onClose: handleClose
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FormCFEComponent, {
                heading: (transformedState === null || transformedState === void 0 ? void 0 : (ref3 = transformedState.heading) === null || ref3 === void 0 ? void 0 : ref3.text) || "",
                description: (transformedState === null || transformedState === void 0 ? void 0 : (ref4 = transformedState.description) === null || ref4 === void 0 ? void 0 : ref4.text) || "",
                buttonText: transformedState.button ? transformedState.button.content[0].btnText : "",
                buttonConfig: transformedState.button ? transformedState.button : null,
                storeData: storeData,
                widgetId: formConfig === null || formConfig === void 0 ? void 0 : formConfig.widget_id,
                toggleFormCompletion: setIsFormSubmit,
                onClose: handleClose,
                open: open
            })
        })
    });
};
/* harmony default export */ var Mobile = (ModernFormMobile);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Form/ModernForm1/index.js





var ModernForm1 = function(props) {
    return checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var Form_ModernForm1 = (ModernForm1);


/***/ })

}]);